import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './app/App'
// The Tailwind entry MUST stay .css — see the note in globals.css.
import './styles/globals.css'
import './styles/landing.scss'
import './styles/sections.scss'
import './styles/legal.scss'

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element #root was not found')
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
